import React from 'react';
import Card from 'react-bootstrap/Card';
import CardGroup from 'react-bootstrap/CardGroup';

export function Dashboard() {
  return (
    <>
    <div className='titleView' style={{marginTop: '20px'}}>
      <h4 style={{textAlign:'center'}}>SELECT AN OPTION FROM THE SIDEBAR MENU TO CONTINUE</h4>
    </div>
    </>
  );
}